import { isObject, isEqual } from 'lodash/fp';

export default (value, emptyValue) => {
  if (isObject(value)) {
    if (value.min === emptyValue.min) {
      return { max: value.max };
    }

    return value;
  } else if (isEqual(value, emptyValue)) {
    return null;
  }

  return value;
};
